import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RequireAdmin = ({ children }) => {
  const token = useSelector((state) => state.global.token);
  const role = useSelector((state) => state.global.userRole);

  const isAuthenticated = Boolean(token);
  const isAdmin = role === "admin";

  // 🚫 Not authenticated at all
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // 🔐 Authenticated but not admin
  if (isAuthenticated && !isAdmin) {
    return <Navigate to="/auth" replace />;
  }

  // ✅ Authenticated as admin
  return children;
};

export default RequireAdmin;
